module.exports = __webpack_public_path__ + "assets/24372949d196dd2f5a994cd177851c27.mp3";